import { Static, Type } from '@sinclair/typebox';

export const inboxSchema = Type.Object({
  object: Type.Literal('Inbox'),
  id: Type.String({ description: 'ID of the Inbox.' }),
  description: Type.Optional(Type.String({ description: 'Description of the Inbox.' })),
  disabled: Type.Boolean({ description: 'Whether messaging is currently disabled for the Inbox.' }),
});

export type Inbox<InboxId = string> = Static<typeof inboxSchema> & { id: InboxId };
